import React, { useEffect, useState, useRef } from "react";
import {
  setItemLocation,
  removeStartPrice,
  removeEndPrice,
  setItemBrands,
  setItemCondition,
  setItemCapacity,
} from "@/lib/store/Slices/FilterSlice";
import { useRouter } from "next/router";
import { useAppDispatch, useAppSelector } from "@/lib/store/hooks";
import { CloseCircleOutlined } from "@ant-design/icons";

function FilterTag() {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const removeQueryPara = () => {
    const { query } = router;
    delete query.q;

    router.push({
      pathname: router.pathname,
      query: query,
    });
  };

  const removeLocationPara = () => {
    const { query } = router;
    delete query.location;
    dispatch(setItemLocation([]));
    router.push({
      pathname: router.pathname,
      query: query,
    });
  };

  const removePriceQuery = () => {
    const { query } = router;
    delete query.start_price;
    delete query.end_price;

    dispatch(removeStartPrice());
    dispatch(removeEndPrice());
    router.push({
      pathname: router.pathname,
      query: query,
    });
  };

  const removeBrandPara = () => {
    const { query } = router;
    delete query.brand;
    dispatch(setItemBrands([]));
    router.push({
      pathname: router.pathname,
      query: query,
    });
  };

  const removeConditionPara = () => {
    const { query } = router;
    delete query.condition;
    dispatch(setItemCondition([]));
    router.push({
      pathname: router.pathname,
      query: query,
    });
  };

  const removeCapacityPara = () => {
    const { query } = router;
    delete query.capacity;
    dispatch(setItemCapacity([]));
    router.push({
      pathname: router.pathname,
      query: query,
    });
  };
  return (
    <div className="filter-tags-container">
      {router.query && router.query.q && (
        <span className="filterTag">
          <span className="filterText">{router.query.q}</span>
          <CloseCircleOutlined
            onClick={removeQueryPara}
            style={{ marginLeft: "8px", cursor: "pointer" }}
          />
        </span>
      )}

      {router.query && router.query.location && (
        <span className="filterTag">
          <span className="filterText">{router.query.location}</span>
          <CloseCircleOutlined
            onClick={removeLocationPara}
            style={{ marginLeft: "8px", cursor: "pointer" }}
          />
        </span>
      )}

      {router.query && router.query.capacity && (
        <span className="filterTag">
          <span className="filterText">{router.query.capacity}</span>
          <CloseCircleOutlined
            onClick={removeCapacityPara}
            style={{ marginLeft: "8px", cursor: "pointer" }}
          />
        </span>
      )}

      {router.query.start_price && router.query.end_price && (
        <span className="filterTag">
          <span className="filterText">
            {" "}
            $ {router.query.start_price} - $
            {router.query.end_price == "Infinity"
              ? "5000+"
              : router.query.end_price}
          </span>
          <CloseCircleOutlined
            onClick={removePriceQuery}
            style={{ marginLeft: "8px", cursor: "pointer" }}
          />
        </span>
      )}

      {router.query && router.query.brand && (
        <span className="filterTag">
          <span className="filterText"> {router.query.brand}</span>
          <CloseCircleOutlined
            onClick={removeBrandPara}
            style={{ marginLeft: "8px", cursor: "pointer" }}
          />
        </span>
      )}

      {router.query && router.query.condition && (
        <span className="filterTag">
          <span className="filterText"> {router.query.condition}</span>
          <CloseCircleOutlined
            onClick={removeConditionPara}
            style={{ marginLeft: "8px", cursor: "pointer" }}
          />
        </span>
      )}
    </div>
  );
}

export default FilterTag;
